<template>
  <div>
    <Header v-if="!isM"/>
    <HeaderMobile v-if="isM"/>
    <router-view/>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import {ResponsiveMixins} from "@/mixins/responsive-mixins";
import HeaderMobile from "@/components/HeaderMobile.vue";

export default {
  name: "TabLayout",
  mixins: [ResponsiveMixins],
  components: {
    HeaderMobile,
    Header
  },
  data() {
    return {
      isM: this.isMobile()
    }
  },
  // mounted() {
  //   if (this.isMobile()) {
  //     alert("手机端");
  //     // this.$router.replace('/m_index');
  //   } else {
  //     alert("pc端");
  //     // this.$router.replace('/login');
  //   }
  // }
}
</script>
